export default __webpack_public_path__ + "static/media/yotta21-Dividend.52902071.mp4";